const pad = (value) => String(value).padStart(2, '0');

const toDateKey = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/**
 * The last day a package bought today could be used, as the API works it out: the purchase date
 * plus the package's months, with the day clamped to the end of a shorter month (31 Jan + 1 → 28/29 Feb).
 * Returns null for a package that never expires.
 */
export const resolvePackageExpiryDateKey = (expiresInMonths, purchaseDate = new Date()) => {
  const months = Number.parseInt(expiresInMonths, 10);
  if (!Number.isInteger(months) || months <= 0) {
    return null;
  }

  const targetMonthIndex = purchaseDate.getMonth() + months;
  const target = new Date(purchaseDate.getFullYear(), targetMonthIndex, 1);
  const lastDayOfTargetMonth = new Date(target.getFullYear(), target.getMonth() + 1, 0).getDate();
  target.setDate(Math.min(purchaseDate.getDate(), lastDayOfTargetMonth));
  return toDateKey(target);
};

export const buildPackageServiceNames = (serviceIds, services, translateName) => (
  (serviceIds || [])
    .map((serviceId) => (services || []).find((service) => service.id === serviceId))
    .filter(Boolean)
    .map((service) => translateName(service.name))
    .join(' + ')
);
